import React, { useState } from "react";

import { Box } from "@mui/material";
import MarketCompany from "./MarketCompany";
import AppConfigUI from "./general_settings/AppConfigUI";
import AdminProjectConfiguration from "./general_settings/AdminProjectConfiguration"
import RenderTabs from "components/Tabs/Tabs";
import ManageAlerts from "./ManageAlerts";
import Ads from "./Ads/Ads";
import MasterData from "./MasterData/MasterData";

const tabs = [
  {
    key: "generalSettings",
    label: "General Settings",
    TabComponent: AppConfigUI,
  },
  {
    key: "projectConfiguration",
    label: "Project Configuration",
    TabComponent: AdminProjectConfiguration
  },
  {
    key: "marketplaceCompanies",
    label: "Marketplace Companies",
    TabComponent: MarketCompany,
  },
  {
    key: "alertsConfig",
    label: "Manage Alerts",
    TabComponent: ManageAlerts,
  },
  {
    key: "Ads",
    label: "Ads",
    TabComponent: Ads,
  },
  {
    key: "MasterData",
    label: "MasterData",
    TabComponent: MasterData,
  },
];

export const SystemAdminSettings = () => {
  const [value, setValue] = useState("generalSettings");

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <RenderTabs
          tabs={tabs}
          selectedTab={value}
          onTabClick={(newValue) => {
            setValue(newValue);
          }}
        />
        {/* <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                >
                    <Tab label="General Settings" {...a11yProps(0)} />
                    <Tab label="Marketplace Companies" {...a11yProps(1)} />
                </Tabs> */}
      </Box>
      {/* <CustomTabPanel value={value} index={0}>
                <AppConfigUI />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <MarketCompany />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                Item Three
            </CustomTabPanel> */}
    </Box>
  );
};
export default SystemAdminSettings;
